export default "__VITE_PUBLIC_ASSET__844abbb8__"